import { proxy } from 'valtio'

const state = proxy({
  intro: true,
  colors: [
    { name: "CUZ47 – Fairfield", colorHex: "#BBB19A" },
    { name: "CUZ4X – Bristol", colorHex: "#98826F" },
    { name: "CUZ4W – Stonebridge", colorHex: "#787878" },
    { name: "CUZ12 – Winchester", colorHex: "#40413D" },
    { name: "CUZ08 – Napier", colorHex: "#191919" },
    { name: "CUZ4Q – Derby", colorHex: "#BD8881" },
    { name: "CUZ4U – Uplands", colorHex: "#884B32" },
    { name: "CUZ4N – Leicester", colorHex: "#C44F44" },
    { name: "CUZ39 – Goldsmith", colorHex: "#C32422" },
    { name: "CUZ4R – Leeds", colorHex: "#C86D1B" },
    { name: "CUZ18 – Oriel", colorHex: "#C8012F" },
    { name: "CUZ13 – Wellington", colorHex: "#960022" },
    { name: "CUZ21 – Magdalene", colorHex: "#600733" },
    { name: "CUZ4T – Moorlands", colorHex: "#594A69" },
    { name: "CUZ09 – Oxford", colorHex: "#080E4F" },
    { name: "CUZSZ – Woodcroft", colorHex: "#94B7C6" },
    { name: "CUZ02 – Aston", colorHex: "#5698B6" },
    { name: "CUZ2U – Vassar", colorHex: "#3F70A4" },
    { name: "CUZ1V – Manchester", colorHex: "#526898" },
    { name: "CUZ4P – Dundee", colorHex: "#1323A3" },
    { name: "CUZ4S – Ullswater", colorHex: "#8DA29A" },
    { name: "CUZ3A – Montcrest", colorHex: "#477D6A" },
    { name: "CUZ1P – Hull", colorHex: "#2B414C" },
    { name: "CUZ26 – Knightsbridge", colorHex: "#1F3179" },
    { name: "CUZ1Y – Edinburgh", colorHex: "#21355D" },
    { name: "CUZ2W – Eynesbury", colorHex: "#CDAD2A" },
    { name: "CUZ53 – Bryanston", colorHex: "#9DAD45" },
    { name: "CUZ1L – Newport", colorHex: "#94BB4B" },
    { name: "CUZ4V – Heathfield", colorHex: "#4C6F46" },
    { name: "CUZ1N – Cardiff", colorHex: "#2B493A" },
    { name: "CUZ28 – Silverdale", colorHex: "#BEBEB7" },
    { name: "CUZ1E – Surrey", colorHex: "#A5A7A4" },
    { name: "CUZ1J – Aberlour", colorHex: "#70747E" },
    { name: "CUZ30 – Silicates", colorHex: "#414141" },
    { name: "CUZ35 – Bromsgrove", colorHex: "#383B39" },
    { name: "CUZ2Q – Dartmouth", colorHex: "#C9C7B9" },
    { name: "CUZ86 – St Andrews", colorHex: "#C1B1A1" },
    { name: "CUZ4A – Caterham", colorHex: "#7A6B58" },
    { name: "CUZ31 – Trevelyan", colorHex: "#696058" },
    { name: "CUZ67 – Kingsmead", colorHex: "#313132" },
    { name: "CUZ3N – Padworth", colorHex: "#CCB1B1" },
    { name: "CUZ3T – Earlscliffe", colorHex: "#C29F96" },
    { name: "CUZ3P – Ackworth", colorHex: "#B17267" },
    { name: "CUZ3L – Malvern", colorHex: "#A26442" },
    { name: "CUZ4L – Warwick", colorHex: "#8D503B" },
    { name: "CUZ3S – Felsted", colorHex: "#B2681B" },
    { name: "CUZ3Q – Tonbridge", colorHex: "#BB4532" },
    { name: "CUZ90 – Edge Hill", colorHex: "#853527" },
    { name: "CUZ63 – Handcross", colorHex: "#853527" },
    { name: "CUZ3W – Moreton", colorHex: "#560D2D" },
    { name: "CUZ4M – Falmouth", colorHex: "#90859B" },
    { name: "CUZ4C – Chichester", colorHex: "#5E5766" },
    { name: "CUZ2T – Holyoke", colorHex: "#5E5766" },
    { name: "CUZ3V – Sidcot", colorHex: "#42192B" },
    { name: "CUZ4D – Dundalk", colorHex: "#3F2823" },
    { name: "CUZ62 – Glenalmond", colorHex: "#3F2823" },
    { name: "CUZ3X – Tettenhall", colorHex: "#1A2858" },
    { name: "CUZ3Z – Ellesmere", colorHex: "#2A4C91" },
    { name: "CUZ4H – Perth", colorHex: "#6785AC" },
    { name: "CUZ4J – Norland", colorHex: "#6C8B9B" },
    { name: "CUZ4B – Brockenhurst", colorHex: "#406B8A" },
    { name: "CUZ1W – Newcastle", colorHex: "#36567A" },
    { name: "CUZ1R – Plymouth", colorHex: "#9AADB8" },
    { name: "CUZ33 – Latimer", colorHex: "#708689" },
    { name: "CUZ4K – Moray", colorHex: "#909E8D" },
    { name: "CUZ3R – Stowe", colorHex: "#4C5645" },
    { name: "CUZ4G – Ambleside", colorHex: "#4F5D5B" },
    { name: "CUZ4E – Grantham", colorHex: "#2F362E" },
    { name: "CUZ3Y – Oakham", colorHex: "#426B45" },
    { name: "CUZ3U – Kingham", colorHex: "#7D8E57" },
    { name: "CUZ4F – Bodmin", colorHex: "#30504D" },
    { name: "CUZ3B – Abertay", colorHex: "#31545E" },
    { name: "CUZ82 – Wesley", colorHex: "#BC8629" },
    { name: "CUZ3M – Lucton", colorHex: "#CCAB2F" },
    { name: "CUZ58 – Dunhurst", colorHex: "#B8A75A" },
    { name: "CUZ1F – Ulster", colorHex: "#919124" },
    { name: "CUZ1K – Camphill", colorHex: "#666D36" }
  ],
  models: ['StandingPod', 'SinglePod', 'DoublePod', 'QuadPod'],
  color: null,
  selectedModel: 'SinglePod',
  selectedMaterial: 'Internal Seating Colour_SP',
  pickedItems: [],
  enabledAddons: [],
  originalMaterials: {}, // Store original complete materials for each material when model loads
  showDoor: true,
  showWheels: false,
  showTV: false,
  frostedGlass: false,
  decalImage: null,
  isDraggingPanel: false,
})

export { state }
